import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, filter } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';

import * as AccountActions from '../account/account.actions';
import * as CabinetActions from './cabinet.actions';
import { of } from 'rxjs';
import { Cabinet } from 'src/app/core/models/cabinet.model';

@Injectable()
export class CabinetEffects {

  loadCabinets$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.authenticated),
      filter(action => !!action.user?.cabinetId),
      switchMap(action => {
        return this.afs.collection<Cabinet>('cabinets', ref => ref.where('cid', '==', action.user.cabinetId)).snapshotChanges();
      }),
      switchMap(actions => {
        const addActions = actions.filter(action => action.type === 'added');
        const loadAction = CabinetActions.addCabinets({
          cabinets: addActions.map(action => {
            return {
              ...action.payload.doc.data(),
              id: action.payload.doc.id,
            };
          })
        });
        const otherActions = actions.filter(action => action.type !== 'added').map(action => {
          switch (action.type) {
            case 'modified':
              return CabinetActions.updateCabinet({
                cabinet: {
                  id: action.payload.doc.id,
                  changes: {
                    ...action.payload.doc.data()
                  }
                }
              });
            case 'removed':
              return CabinetActions.deleteCabinet({
                id: action.payload.doc.id
              });
            default:
              break;
          }
        });
        const allActions = [
          loadAction,
          ...otherActions
        ];
        return of(...allActions);
      })
    );
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.logout),
      map(() => CabinetActions.clearCabinets())
    );
  });



  constructor(
    private actions$: Actions,
    private afs: AngularFirestore
  ) {}

}
